module.exports = __webpack_public_path__ + "static/media/brandmark.ab2cdaaa.png";